import * as React from 'react';
import classnames from 'classnames';

type Props = {
  value: boolean,
  onChange: (a: boolean) => void,
  isEditable?: boolean
};

class Switch extends React.PureComponent<Props> {
  handleToggle = (): void => {
    const { value, onChange, isEditable } = this.props;

    if (isEditable === false) {
      return;
    }

    onChange(!value);
  };

  render() {
    const { value, isEditable } = this.props;

    const switchClasses = classnames({
      'switch': true,
      'switch--on': value,
      'switch--disabled': !isEditable
    });

    return (
      <section
        className={switchClasses}
        onClick={this.handleToggle}
      />
    );
  }
}

export default Switch;
